import { render } from "./ShipmentsListing.vue?vue&type=template&id=1897a50c&scoped=true&ts=true"
import script from "./ShipmentsListing.vue?vue&type=script&lang=ts"
export * from "./ShipmentsListing.vue?vue&type=script&lang=ts"

import "./ShipmentsListing.vue?vue&type=style&index=0&id=1897a50c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1897a50c"]])

export default __exports__